import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';

import Subscription from '../Forms/Subscription';

import CallToAction from '../CallToAction';
import {
  Container,
  Column,
  Card,
  Text,
} from '../../styles/Components/Cards/SubscriptionCard';

const SubscriptionCard = ({ theme }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Card className="subscription-card" theme={theme}>
        <Text>
          <p className="heading">
            {t('Get the best maintenance advice, straight to your inbox.')}
          </p>
          <p className="subhead">{t('Sign up for newsletter updates')}</p>
        </Text>
        <Subscription />
      </Card>
      <Column>
        <p>{t('OR')}</p>
        <CallToAction
          url="/free-trial-signup"
          label={t('Sign Up for Free')}
          variant="Outline - Dark"
          size="md"
        />
      </Column>
    </Container>
  );
};

export default SubscriptionCard;
